import WidgetImagePresentation from 'components/WidgetImage/WidgetImagePresentation'

export default {
  Presentation: WidgetImagePresentation,
}
